import { useState } from "react";
import Layout from "../components/Layout";
import Link from "next/link";
import useSWR from "swr";
import Head from "next/head";

import api from "../services/api";
import { useAuth } from "../hooks/useAuth";

import NoContentPlaceholder from "../components/NoContentPlaceholder";
import Button from "../components/Button";
import LoginModal from "../components/LoginModal";
import MediaSections from "../components/MediaSections";
import NeedLoginLayoutStub from "../components/NeedLoginLayoutStub";

export default function Me() {
  const { apiLoaded, user, singleOrganization, token } = useAuth();
  const forceSingleOrg =
    typeof navigator !== "undefined" &&
    navigator.userAgent.indexOf("eventive/") !== -1
      ? navigator.userAgent.substring(
          navigator.userAgent.indexOf("eventive/") + 9
        )
      : null;
  const { data, mutate, error } = useSWR(
    apiLoaded &&
      token &&
      `watch/my_content?token=${token}${
        singleOrganization || forceSingleOrg
          ? `&owner=${forceSingleOrg || singleOrganization.id}`
          : ""
      }`,
    k => api.get(k).then(r => r.data)
  );

  if (apiLoaded && !token) {
    return (
      <NeedLoginLayoutStub
        key="stub"
        text="You must be logged in to view your content."
      />
    );
  }

  if (!data) {
    return <Layout key="load" loader />;
  }

  return (
    <Layout
      title={`${user.details.name ? `${user.details.name}'s` : "Your"} ${
        singleOrganization ? singleOrganization.name : ""
      } Content Library`}
    >
      <Head>
        <title>
          My Content |{" "}
          {singleOrganization ? singleOrganization.name : "Eventive Virtual"}
        </title>
      </Head>
      {data?.sections.some(s => s.items.length) ? (
        <div>
          <MediaSections
            sections={data.sections}
            displayMode="default"
            forceGrid
            includeTicketDetails
            hideIfEmpty
          />
        </div>
      ) : (
        <NoContentPlaceholder
          text={
            error ? (
              `Unable to load your content: ${error.message}`
            ) : (
              <>
                You don't have any content in your library &ndash; try{" "}
                <Link href="/">
                  <a className="underline hover:text-gray-200">
                    finding something new
                  </a>
                </Link>
                !
              </>
            )
          }
          emoji="🍿"
        />
      )}
    </Layout>
  );
}
